/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useState, useEffect } from 'react';
import { 
  useLocation, 
  useNavigate
} from 'react-router-dom';
import Footer from '../Footer';
import Header from '../Header';
import SidebarWrapper from '../SidebarWrapper';
import type { LoginAppRights, MenuItem } from '../types/types';
import { MenuItems } from 'src/components/menuItems';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';

interface MainLayoutProps {
  children: React.ReactNode;
}

export default function MainLayout({ children }: MainLayoutProps): React.JSX.Element {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const url = useLocation();
  const navigate = useNavigate();

  const appRights = localStorage?.getItem('appRights') ?? "";
  const rolePermission = appRights !== "" ? JSON.parse(appRights) as LoginAppRights[] : [];

  const menuItems: MenuItem[] = MenuItems;

  const clearAllNotifications = (): void => {
    const currentTime = Date.now();
 
    NotificationManager.listNotify.forEach((notification: any) => {
      if (notification.createTime && currentTime - notification.createTime > 8000) {
        NotificationManager.remove(notification);
      }
    });
  };
  const patchNotificationManager = () : void=> {
    const types = ['success', 'error', 'info', 'warning'];
  
    types.forEach((type) => {
      //@ts-ignore
      const original = NotificationManager[type];
   //@ts-ignore
      NotificationManager[type] = function (...args: any[]) {
        const [message, title = '', duration = 5000] = args;
  
        // Remove all existing notifications before showing a new one
        NotificationManager.listNotify?.forEach((n: any) => {
          NotificationManager.remove(n);
        });
  
         
        original.call(this, message, title, duration);
  
        // Add a createTime property
        const lastIndex = NotificationManager.listNotify.length - 1;
        const notification = NotificationManager.listNotify[lastIndex];
        if (notification) {
          //@ts-ignore
          notification.createTime = Date.now();
        }
      };
    });
  };
  
  useEffect(() => {
    patchNotificationManager();
  }, []);
  
 
  
  // Find the menuKey for the current path, supporting partial path matching
  const searchMenu = (): string => {
    const urlPath = url.pathname;
    let menuKey = "";
    
    // First try exact match
    for (const item of menuItems) {
      const normalizedMenuKey = item.link;
      
      // Match exact links for menus without submenus
      if (normalizedMenuKey === urlPath) {
        menuKey = item.rightCode ?? "";
        break;
      }
      
      // Match links within submenu if exists
      if (item.subMenu) {
        for (const feature of item.subMenu) {
          const normalizedFeatureKey = feature.link;
          if (normalizedFeatureKey === urlPath) {
            menuKey = feature.rightCode ?? "";
            break;
          }
        }
        if (menuKey) break;
      }
    }
    // If no exact match found, try matching base paths (for cases like /template/new-template)
    if (!menuKey) {
      // Get the base path (first segment after the root)
      const pathSegments = urlPath.split('/').filter(Boolean);
      if (pathSegments.length > 0) {
        const basePath = '/' + pathSegments[0];
        
        for (const item of menuItems) {
          if (item.link === basePath) {
            menuKey = item.rightCode ?? "";
            break;
          }
          
          // Also check in submenus
          if (item.subMenu) {
            for (const feature of item.subMenu) {
              if (feature.link === basePath) {
                menuKey = feature.rightCode ?? "";
                break;
              }
            }
            if (menuKey) break;
          }
        }
      }
    }
    
    return menuKey;
  };

  useEffect(() => {
    clearAllNotifications();
  
    if (url.pathname === '/dashboard') {
      return;
    }
    if(rolePermission.length <= 0 ){
      navigate('/');
      return;
    }
    // Get current menu right code (including base path matching)
    const menuRightCode = searchMenu();
    
    // Skip permission check for user edit pages
    const isManageUsersEditPath = /^\/admin\/manage-users\/edit\/\d+$/.test(url.pathname);
    if (isManageUsersEditPath) {
      return;
    }
    
    // Check if user has permission for this right code
    let hasPermission = false;
    if (menuRightCode !== "") {
      // Check if the right code exists in user's permissions
      hasPermission = rolePermission.some(role => role.rightCode === menuRightCode);
    }
    // Redirect to 404 if no matching menu item or no permission
    if (!menuRightCode || !hasPermission) {
      navigate('/404');
    }
  }, [url, rolePermission, navigate]);

  return (
  <div className="flex min-h-screen w-full">
      <SidebarWrapper isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
      <div className="flex flex-col flex-1 w-0">
        <Header />
        <div className="flex-1 px-10 py-5 overflow-auto">
          {React.Children.map(children, (child) =>
            React.isValidElement(child)
              ? React.cloneElement(child as React.ReactElement<{ isCollapsed?: boolean }>, { isCollapsed })
              : child
          )}
        </div>
        <Footer />
      </div>
    </div>
  );
}